import Link from 'components/Globals/Base/Link';
import { NextCustomImage } from 'components/Image';
import type { RankingMentioning, Year } from 'interfaces/content/Ranking';
import Rank from 'components/Ranking/Rank';
import { color } from 'styles/globals';
import { RANKING_V2_PAGE } from 'constants/testsIds/rankingV2Page';
import RankingListItemWrapper from './rankingsListItemStyles';
import YearList from './YearList';

interface RankingsListItemProps extends RankingMentioning {
  className?: string;
  hasArrow?: boolean;
}

const RankingsListItem = ({
  title,
  description,
  slug,
  years,
  image,
  imageAlt,
  buttonTitle,
  postId,
  className = '',
  rank = null,
  trackingData,
  hasArrow = false,
  externalUrl,
  listTypeAlias,
}: RankingsListItemProps) => {
  const yearsDesc = [...years].sort((aYear: Year, bYear: Year) => Number(bYear.year) - Number(aYear.year));
  const latestYear: Year = yearsDesc[0];
  const isExternal = listTypeAlias === 'external';

  const mainHref = isExternal ? latestYear?.externalUrl || externalUrl || slug : slug;

  const yearsForList: Year[] = isExternal
    ? years.map((year) => ({
        ...year,
        permalink: year.externalUrl || year.permalink,
      }))
    : years;

  return (
    <RankingListItemWrapper
      className={className}
      data-cy={RANKING_V2_PAGE.RANKING_LIST_ITEM}
    >
      {image && !rank && (
        <Link
          href={mainHref}
          dataCy='imageLink'
          trackingData={
            trackingData && {
              ...trackingData,
            }
          }
        >
          <NextCustomImage
            className='image'
            width='700'
            height='455'
            src={`${image.split('?')[0]}?w=700`}
            alt={imageAlt || title || 'Ranking image'}
            data-cy='image'
          />
        </Link>
      )}
      {rank && (
        <div className='rank'>
          <NextCustomImage
            width='95'
            height='64'
            src={image || ''}
            style={{}}
            alt=''
          />
          {rank !== '0' ? (
            <Rank
              rank={rank}
              color={`${color.primaryRed}`}
              className='rankings-mentioning'
            />
          ) : null}
        </div>
      )}
      <Link
        href={mainHref}
        className='title'
        dataCy='title'
        trackingData={
          trackingData && {
            ...trackingData,
          }
        }
      >
        {title}
      </Link>
      <p
        className='excerpt'
        data-cy='description'
      >
        {description}
      </p>
      <div className='bottom-container'>
        <Link
          className='black-button'
          type='primaryButton'
          size={{ default: 'large' }}
          href={mainHref}
          hasRightArrow={hasArrow}
          dataCy='btnViewList'
          trackingData={
            trackingData && {
              ...trackingData,
            }
          }
        >
          {buttonTitle ?? `view ${latestYear.year || 'in'} list`}
        </Link>
        <YearList
          years={yearsForList}
          listId={postId}
        />
      </div>
    </RankingListItemWrapper>
  );
};

export default RankingsListItem;
